{
  "badge": "⭐ Ce spun clienții noștri",
  "title": "Testimoniale Reale",
  "subtitle": "Feedback autentic de la utilizatori care au folosit platforma noastră pentru a cumpăra sau vinde vehicule",
  "loading": "Se încarcă testimoniale...",
  "no_testimonials": "Nu există testimoniale disponibile momentan.",
  "stats": {
    "average_rating": "Rating mediu",
    "verified_reviews": "Recenzii verificate",
    "customer_satisfaction": "Satisfacție clienți",
    "response_time": "Timp mediu răspuns"
  },
  "cta": {
    "title": "Vrei să lași și tu un testimonial?",
    "description": "Dacă ai folosit platforma noastră, ne-ar plăcea să auzim experiența ta! Testimonialul tău va fi verificat înainte de publicare.",
    "button": "Lasă un testimonial"
  },
  "form": {
    "title": "Lasă-ne un testimonial",
    "subtitle": "Toate câmpurile sunt obligatorii. Testimonialul va fi verificat înainte de publicare.",
    "name_label": "Nume complet *",
    "name_placeholder": "Ex: Ion Popescu",
    "email_label": "Email *",
    "email_placeholder": "ion@email.ro",
    "city_label": "Oraș *",
    "city_placeholder": "București",
    "user_type_label": "Tipul utilizatorului *",
    "user_types": {
      "buyer": "Cumpărător",
      "seller": "Vânzător",
      "dealer": "Dealer auto"
    },
    "rating_label": "Rating *",
    "message_label": "Mesajul tău *",
    "message_placeholder": "Spune-ne despre experiența ta cu platforma RO Auto Market...",
    "character_count": "caractere",
    "cancel_button": "Anulează",
    "submit_button": "Trimite testimonial",
    "submitting": "Se trimite..."
  }
}